import { useMutation, useQuery, useQueryClient } from "react-query";
import { OrganizationKeyName } from "../../../model/Organization";
import { organizationHttp } from "./organization-http";

export const organizationCacheKeys = {
  organizations: "organizations",
  organization: "organization",
};

export const useGetOrganization = (
  organizationKeyName?: OrganizationKeyName
) => {
  return useQuery(
    [organizationCacheKeys.organization, organizationKeyName],
    () => organizationHttp.getOrganization(organizationKeyName),
    { refetchOnWindowFocus: false, enabled: !!organizationKeyName }
  );
};

export const useUpdateOrganization = (keyname?: string) => {
  const queryClient = useQueryClient();

  return useMutation(organizationHttp.updateOrganization, {
    onSuccess: async () => {
      await queryClient.refetchQueries(organizationCacheKeys.organizations);
      if (keyname) {
        await queryClient.refetchQueries([
          organizationCacheKeys.organization,
          keyname,
        ]);
      }
    },
  });
};

export const useCreateOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation(organizationHttp.createOrganization, {
    onSuccess: async () => {
      await queryClient.refetchQueries(organizationCacheKeys.organizations);
    },
  });
};

export const useUploadOrganizationReceiptImage = (keyName?: string) => {
  const queryClient = useQueryClient();
  return useMutation(organizationHttp.uploadOrganizationReceiptImage, {
    onSuccess: async () => {
      if (keyName) {
        await queryClient.refetchQueries([
          organizationCacheKeys.organization,
          keyName,
        ]);
      }
    },
  });
};
